"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeFilterConfig = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const compareNumbers_1 = require("./selectFunctions/compareNumbers");
const equals_1 = require("./selectFunctions/equals");
const inList_1 = require("./selectFunctions/inList");
const orderBy_1 = require("./selectFunctions/orderBy");
const orderBySum_1 = require("./selectFunctions/orderBySum");
const applyAllFilters = (selectFunctions) => (loanTapeRecords) => lodash_1.default.reduce(selectFunctions, (selectedLoanTapeRecords, selectFn) => selectFn(selectedLoanTapeRecords), loanTapeRecords);
const createSelectFunction = (compatibleConfig) => {
    switch (compatibleConfig.operation) {
        case 'orderBy':
            return (0, orderBy_1.orderBy)(compatibleConfig);
        case 'orderBySum':
            return (0, orderBySum_1.orderBySum)(compatibleConfig);
        case 'equals':
        case 'notEqual':
            return (0, equals_1.equals)(compatibleConfig);
        case 'lessThan':
        case 'greaterThan':
        case 'lessThanOrEqual':
        case 'greaterThanOrEqual':
            return (0, compareNumbers_1.compareNumbers)(compatibleConfig);
        case 'inList':
        case 'notInList':
            return (0, inList_1.inList)(compatibleConfig);
        default:
            throw new common_1.error.FinleyError('invalid config operation', {
                metadata: { logMeta: { config: compatibleConfig?.config } },
            });
    }
};
const ensureCompatibleConfig = (config, loanTape) => {
    switch (config.operation) {
        case 'orderBy':
            return orderBy_1.CompatibleOrderByConfig.create(config, loanTape);
        case 'orderBySum':
            return orderBySum_1.CompatibleOrderBySumConfig.create(config, loanTape);
        case 'equals':
        case 'notEqual':
            return equals_1.CompatibleEqualsConfig.create(config, loanTape);
        case 'lessThan':
        case 'greaterThan':
        case 'lessThanOrEqual':
        case 'greaterThanOrEqual':
            return compareNumbers_1.CompatibleCompareNumbersConfig.create(config, loanTape);
        case 'inList':
        case 'notInList':
            return inList_1.CompatibleInListConfig.create(config, loanTape);
        default:
            throw new common_1.error.FinleyError('invalid config operation', {
                metadata: { logMeta: { config } },
            });
    }
};
/**
 * Creates a select function, which can be used to select a subset of LoanTapes
 * in a given array based on a provided config object.
 *
 * @param config FilterConfig
 * @returns SelectFunction
 */
const executeFilterConfig = ({ configs, loanTapeRecords, }) => {
    const compatibleConfigs = configs.map((config) => ensureCompatibleConfig(config, loanTapeRecords));
    const filterFunction = applyAllFilters(compatibleConfigs.map(createSelectFunction));
    return filterFunction(loanTapeRecords);
};
exports.executeFilterConfig = executeFilterConfig;
//# sourceMappingURL=concentrationLimitFilterFactoryV2.js.map